import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import modernist from '../modernistTheme';

const Wrap = styled.div`
  position: relative;
`;

const Panel = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 30;
  margin-top: 4px;
  background: ${modernist.bg};
  border: 2px solid ${modernist.text};
  box-shadow: ${modernist.shadowLg};
`;

// Chrome-only: positions `panel` under `trigger`, closes on outside click.
// Callers own the open/close state and supply their own trigger + panel content.
const AnchoredDropdown = ({ open, onClose, trigger, panel }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;

    function onDocMouseDown(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }

    document.addEventListener('mousedown', onDocMouseDown);
    return () => document.removeEventListener('mousedown', onDocMouseDown);
  }, [open, onClose]);

  return (
    <Wrap ref={ref}>
      {trigger}
      {open && <Panel>{panel}</Panel>}
    </Wrap>
  );
};

export default AnchoredDropdown;
